export default __webpack_public_path__ + "static/media/logo16.54aeb4ba.svg";